import jQuery from './components/JQuery';
import  './components/Bootstrap';
import './components/CookieConsent';
import './components/FullHeightIOS.js';
import './components/TouchDevice.js';
import './components/FormValidation.js';
import './components/Tooltip.js';
import initMobileNav from './components/MobileNav.js';
import initMobileNavFilters from './components/MobileNavFilters.js';
import initDropMenu from './components/DropMenu.js';
import initSwiper from './components/Swiper.js';
import initLavaLamp from './components/LavaLamp.js';
import initSearchFocusOnOpen from './components/SearchFocusOnOpen.js';
import initSlickCarousel from './components/SlickCarousel.js';
import initOpenClose from './components/OpenClose.js';
import initHeadroom, { initPinning } from './components/Headroom.js';
import initWrapperExtraPadding from './components/WrapperExtraPadding.js';
import initVideoExpandableBlock from './components/VideoExpandableBlock.js';
import initLazyLoad from './components/LazyLoad.js';
import initBlockCover from './components/BlockCover.js';
import initMediaelementPlayer from './components/MediaelementPlayer.js';
import initPopups from './components/Popups.js';
import initAddClasses from './components/AddClasses.js';
import initAjaxFilters from './components/AjaxFilters.js';
import initLoadMore from './components/LoadMore.js';
import initCustomForms from './components/CustomForms.js';
import initFancybox from './components/Fancybox.js';
import initShowMoreBlock from './components/ShowMoreBlock.js';
import initFlexMasonry from './components/FlexMasonry.js';
import initStickyScrollBlock from './components/StickyScrollBlock.js';
import initMasonry from './components/Masonry.js';
import initClipboard from './components/Clipboard.js';
import initShowPassword from './components/ShowPassword.js';
import initStickySidebar from './components/StickySidebar.js';
import initPostInfoTextWrapp from './components/PostInfoTextWrapp.js';
import { initGSAP } from './components/GSAP.js';
import initJsStyles from  './components/JsStyles';
import initIntlTelInput from  './components/IntlTelInput.js';
import initFreeform from './components/Freeform';

window.initFlexMasonry = initFlexMasonry;
window.initMediaelementPlayer = initMediaelementPlayer;
window.initCustomForms = initCustomForms;
window.initMobileNavFilters = initMobileNavFilters;
window.initGSAP = initGSAP;
window.initStickyScrollBlock = initStickyScrollBlock;
window.initPinning = initPinning;

jQuery(function() {
  initMobileNav();
  initDropMenu();
  initSwiper();
  initLavaLamp();
  initSearchFocusOnOpen();
  initSlickCarousel();
  initOpenClose();
  initHeadroom();
  initWrapperExtraPadding();
  initVideoExpandableBlock();
  initLazyLoad();
  let portrait = window.matchMedia("(orientation: portrait)");
  portrait.addEventListener('change', function(e) {
    window.ScrollTrigger.refresh();
    initLazyLoad();
    initBlockCover();
  });
  initBlockCover();
  initMediaelementPlayer();
  initPopups();
  initAddClasses();
  initAjaxFilters();
  initLoadMore();
  initCustomForms();
  initFancybox();
  initShowMoreBlock();
  initFlexMasonry();
  initMasonry();
  initStickyScrollBlock();
  initClipboard();
  initShowPassword();
  initStickySidebar();
  initPostInfoTextWrapp();
  initGSAP();
  initJsStyles();
  initIntlTelInput();
  initFreeform();
});
